
import Notification from "./Notification";

export default function NotificationPanel({ index, dataPanel, callback }) {

    let classPanel = index == 0 ? 'tab-pane fade active show' : 'tab-pane fade';

    return (
        <div className={classPanel} key={'kt_topbar_notifications_' + index} id={'kt_topbar_notifications_' + dataPanel.id} role='tabpanel' >
            <div className='scroll-y mh-325px my-5 px-8'>

                {
                    dataPanel.notificaciones.map((element, index2) =>
                        <Notification key={'notificacion_' + index + '-' + index2} dataNotificacion={element} callback={callback} notificationId={dataPanel.id}></Notification>
                    )
                }
            </div>
        </div>
    )
}
